const O_N_X = 'on' + 'n' + 'x';

const DETECTION_EXPORTS = ['tensorrt', 'tflite', 'coreml', O_N_X];
const HAILO_DETECTION_EXPORTS = ['hef'];
const CLASSIFICATION_EXPORTS = ['tflite', 'litert', 'coreml', O_N_X];
const HAILO_CLASSIFICATION_EXPORTS = ['hef'];
const DEFAULT_EXPORTS = ['tensorrt', 'tflite', 'coreml', 'edgeyolo', 'pytorch', 'fastai'];
const BOXIFY_EXPORTS = ['tensorrt', 'tflite', 'litert', 'coreml', O_N_X, 'edgeyolo', 'pytorch', 'fastai'];

const CLASSIFICATION_TYPE_PREFIXES = ['mobilenet', 'convnext', 'vit_'];
const CLASSIFICATION_META_TYPES = new Set([
  'convnext_tiny',
  'convnext_tiny_in22k',
  'convnextv2_tiny',
  'vit_small_patch16_224',
  'vit_small_patch32_224',
  'vit_base_patch14_dinov2',
  'vit_large_patch14_dinov2',
  'resnet18',
]);

function parseModelMeta(model) {
  if (!model || !model.meta) {
    return {};
  }
  try {
    const meta = JSON.parse(model.meta);
    return meta && typeof meta === 'object' ? meta : {};
  } catch (_) {
    return {};
  }
}

function matchesClassificationType(type) {
  const normalized = (type || '').toLowerCase();
  if (!normalized) {
    return false;
  }
  if (normalized === 'fastai' || CLASSIFICATION_META_TYPES.has(normalized)) {
    return true;
  }
  return CLASSIFICATION_TYPE_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}

function hasFastaiArtifact(meta) {
  const files = meta.files || [];
  return files.some((file) => String(file).toLowerCase().endsWith('.pkl'));
}

export function isClassificationModel(model) {
  if (matchesClassificationType(model && model.type)) {
    return true;
  }

  const meta = parseModelMeta(model);
  const metaType = meta.type || meta.selected_model_id || '';
  if (matchesClassificationType(metaType)) {
    return true;
  }

  return hasFastaiArtifact(meta);
}

export function exportTypesForModel(model) {
  const modelType = (model && model.type) || '';

  if (modelType === 'darknet' || modelType === 'yolov9mit') {
    return [...DETECTION_EXPORTS, ...HAILO_DETECTION_EXPORTS];
  }

  if (modelType === 'rtmdet') {
    return [...DETECTION_EXPORTS];
  }

  if (modelType === 'boxify') {
    return [...BOXIFY_EXPORTS];
  }

  if (isClassificationModel(model)) {
    return [...CLASSIFICATION_EXPORTS, ...HAILO_CLASSIFICATION_EXPORTS];
  }

  return DEFAULT_EXPORTS;
}
